module.exports = __webpack_public_path__ + "assets/img/logo.b0f1c43c.png";